import { render, staticRenderFns } from "./WorkforceCostDashboardOverview.vue?vue&type=template&id=06165592&scoped=true"
import script from "./WorkforceCostDashboardOverview.vue?vue&type=script&lang=js"
export * from "./WorkforceCostDashboardOverview.vue?vue&type=script&lang=js"
import style0 from "./WorkforceCostDashboardOverview.vue?vue&type=style&index=0&id=06165592&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06165592",
  null
  
)

export default component.exports